export const environment = {
  production: false,
  apiUrl: 'https://schools-api-a.36t.io/api/v1',

  // Spreadsheet export on the students, parents, attendance, exams and results screens.
  excelExport: true,

  // Where a school is sent to ask for a bigger plan. Shown on the "plan limit
  // reached" popup; leave empty and the popup names the company without a
  // link, rather than pointing people at an address nobody reads.
  supportEmail: '',

  // No demo sign-ins on a deployed build: a real school must never see a
  // shared password on its sign-in page. See environment.ts.
  demoAccounts: [] as { label: string; scope: string; email: string }[],
  demoPassword: ''
};
